<template>
  <div class="calendar-swiper">
    <Swiper
      class="swiper-card"
      ref="swiperCard"
      :options="{
        ...swiperCardOptions,
        centeredSlides: list.length == 1,
        navigation: {
          nextEl: '.swiper-card-button-next.next-' + swiperIndex,
          prevEl: '.swiper-card-button-prev.prev-' + swiperIndex
        }
      }"
      @slideChange="handleSwiperCardChange"
    >
      <SwiperSlide
        class="swiper-slide"
        v-for="(card, index) in list"
        :key="index"
        :class="{ 'full-slide': isFullSlide(card) }"
      >
        <CardItem
          ref="cardItem"
          :index="index"
          :item="card"
          :showDate="false"
          :canFull="true"
          :isShow="isShow && index >= activeSwiperIndex - 1 && index <= activeSwiperIndex + 2"
        />
      </SwiperSlide>
    </Swiper>
    <div class="swiper-card-button-next" :class="'next-' + swiperIndex"></div>
    <div class="swiper-card-button-prev" :class="'prev-' + swiperIndex"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import CardItem from "./CardItem.vue";
export default {
  name: "GameCalendarSwiper",
  components: { Swiper, SwiperSlide, CardItem },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    swiperIndex: {
      type: Number,
      default: 0
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeSwiperIndex: 0,
      swiperCardOptions: {
        initialSlide: 0,
        slidesPerView: "auto",
        spaceBetween: 0,

        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        }
      }
    };
  },
  methods: {
    handleSwiperCardChange(swiper) {
      this.activeSwiperIndex = this.$refs.swiperCard.$swiper.activeIndex;
    },
    isFullSlide(data) {
      // 类型新游，并且有视频
      const bigVideo = data.big_video_format && data.big_video_format.src ? data.big_video_format : null;

      return !!bigVideo;
    }
  }
};
</script>

<style lang="less" scoped>
.calendar-swiper {
  width: 100%;
  height: 100%;
}
.swiper-card {
  position: relative;
  top: -20px;
  height: calc(100% + 20px);
  width: 100%;
  padding: 58px 0 0;
  // 3d
  perspective: 440px;
  // overflow: visible !important;
  /deep/ .swiper-wrapper {
    height: 100%;
  }
  .swiper-slide {
    width: 50%;
    opacity: 0;
    transition: all 0.3s;
    padding: 0 43px;
    &-active,
    &-next {
      opacity: 1;
    }
  }
  .full-slide {
    width: 100%;
    /deep/ .full-card {
      position: relative;
      left: -43px;
      top: -38px;
      width: calc(100% + 86px);
      height: calc(100% + 38px);
    }
  }
}
.swiper-card-button-next {
  position: absolute;
  right: -44px;
  top: 40%;
  z-index: 2;
  transform: translateY(-50%);
  cursor: pointer;
  &.swiper-button-disabled {
    &::after {
      display: none;
    }
  }
  &::after {
    content: "";
    display: block;
    width: 92px;
    height: 92px;
    background: url("~@/assets/images/home-banner-next-icon.png") no-repeat;
    background-size: 100% 100%;
  }
}
.swiper-card-button-prev {
  position: absolute;
  left: -44px;
  top: 40%;
  z-index: 2;
  transform: translateY(-50%);
  cursor: pointer;
  &.swiper-button-disabled {
    &::after {
      display: none;
    }
  }
  &::after {
    content: "";
    display: block;
    width: 92px;
    height: 92px;
    background: url("~@/assets/images/home-banner-next-icon.png") no-repeat;
    background-size: 100% 100%;
    transform: rotate(180deg);
  }
}
</style>
